import Vue from 'vue';
import Router from 'vue-router';

const Dashboard = r => require.ensure([], () => r(require('@/components/pages/dashboard')), 'dashboard');
const SpInfo = r => require.ensure([], () => r(require('@/components/pages/sp-info')), 'sp-info');
const AccountInfo = r => require.ensure([], () => r(require('@/components/pages/account-info')), 'account-info');
const Tickets = r => require.ensure([], () => r(require('@/components/pages/tickets')), 'repair-tickets');
const RepairForm = r => require.ensure([], () => r(require('@/components/pages/repair-form')), 'repair-form');
const RepairTemplate = r => require.ensure([], () => r(require('@/components/pages/repair-template')), 'repair-template');
const CreateRepairForm = r => require.ensure([], () => r(require('@/components/pages/repair-form-edit')), 'repair-form-edit');
const CreateRepairTemplate = r => require.ensure([], () => r(require('@/components/pages/repair-template-edit')), 'repair-template-edit');
const SpSetting = r => require.ensure([], () => r(require('@/components/pages/sp-setting')), 'sp-setting');
const DashboardSetting = r => require.ensure([], () => r(require('@/components/pages/dashboard-setting')), 'dashboard-setting');
const DashboardShortcut = r => require.ensure([], () => r(require('@/components/pages/dashboard-shortcut')), 'dashboard-shortcut');
const Announcement = r => require.ensure([], () => r(require('@/components/pages/announcement')), 'announcement-setting');
const AnnouncementModify = r => require.ensure([], () => r(require('@/components/pages/announcement-modify')), 'announcement-setting');
const ServiceBranch = r => require.ensure([], () => r(require('@/components/pages/article/service_branch')), 'article');
const ChargeSpec = r => require.ensure([], () => r(require('@/components/pages/article/charge_spec')), 'article');
const RepairMember = r => require.ensure([], () => r(require('@/components/pages/repair-member')), 'repair-member');

const ReportView = r => require.ensure([], () => r(require('@/components/pages/repair-view')), 'repairchunk');
const ReportServiceTicketView = r => require.ensure([], () => r(require('@/components/pages/service-ticket-view')), 'repairchunk');

const WeChat = r => require.ensure([], () => r(require('@/components/pages/wechat')), 'wechatchunk');
const WeChatMenu = r => require.ensure([], () => r(require('@/components/pages/wechat-menu')), 'wechatchunk');
const WeChatAuthorizerMenu = r => require.ensure([], () => r(require('@/components/pages/wechat-authorizers')), 'wechatchunk');
const WeChatMenuOld = r => require.ensure([], () => r(require('@/components/pages/wechat-menu-old')), 'wechatchunk');
const WeChatSubscribeReply = r => require.ensure([], () => r(require('@/components/pages/wechat-subscribe-reply')), 'wechatchunk');

const Binding = r => require.ensure([], () => r(require('@/components/pages/binding')), 'bindthunk');

const SubDomainAudit = r => require.ensure([], () => r(require('@/components/pages/mgr/sub-domain-audit')), 'adminchunk');
const ServiceProviderMgr = r => require.ensure([], () => r(require('@/components/pages/mgr/sp-mgr')), 'adminchunk');
const CustomerDomainAudit = r => require.ensure([], () => r(require('@/components/pages/mgr/customer-domain-audit')), 'adminchunk');
const RevenueExpenditure = r => require.ensure([], () => r(require('@/components/pages/mgr/revenue-expenditure')), 'adminchunk');
const MiniAppView = r => require.ensure([], () => r(require('@/components/pages/mgr/miniapp')), 'adminchunk');
const CompileAppView = r => require.ensure([], () => r(require('@/components/pages/mgr/app')), 'adminchunk');
const FeedbackView = r => require.ensure([], () => r(require('@/components/pages/mgr/feedback')), 'adminchunk');

const DevicePresentView = r => require.ensure([], () => r(require('@/components/pages/device-present')), 'dpchunk');
const DevicePresentModify = r => require.ensure([], () => r(require('@/components/pages/device-tmpl-edit')), 'dpchunk');

const DevLogin = r => require.ensure([], () => r(require('@/components/pages/dev-login')), 'dev-login');

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'navigation__active',
  routes: [
    {
      path: '/dev-login',
      name: 'DevLogin',
      component: DevLogin
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/tickets',
      name: 'Tickets',
      component: Tickets
    },
    {
      path: '/tickets/m/:rm_id',
      name: 'RepairMemberTickets',
      component: Tickets
    },
    {
      path: '/wechat/info',
      name: 'WeChat',
      component: WeChat
    },
    {
      path: '/wechat/menu',
      name: 'WeChatMenuOld',
      component: WeChatMenuOld
    },
    {
      path: '/wechat/subscribe_reply',
      name: 'WeChatSubscribeReply',
      component: WeChatSubscribeReply
    },
    {
      path: '/authorizer/list',
      name: 'WeChatAuthorizerMenu',
      component: WeChatAuthorizerMenu
    },
    {
      path: '/authorizer/menu',
      name: 'WeChatMenu',
      component: WeChatMenu
    },
    {
      path: '/account',
      name: 'AccountInfo',
      component: AccountInfo
    },
    {
      path: '/info',
      name: 'SpInfo',
      component: SpInfo
    },
    {
      path: '/member',
      name: 'RepairMember',
      component: RepairMember
    },
    {
      path: '/setting',
      name: 'SpSetting',
      component: SpSetting
    },
    {
      path: '/app/dashboard',
      name: 'DashboardSetting',
      component: DashboardSetting
    },
    {
      path: '/app/shortcut',
      name: 'DashboardShortcut',
      component: DashboardShortcut
    },
    {
      path: '/app/announcement',
      name: 'Announcement',
      component: Announcement
    },
    {
      path: '/app/announcement-create',
      name: 'CreateAnnouncement',
      component: AnnouncementModify
    },
    {
      path: '/app/announcement-edit/:id',
      name: 'EditAnnouncement',
      component: AnnouncementModify
    },
    {
      path: '/app/article/servicebranch',
      name: 'ServiceBranch',
      component: ServiceBranch
    },
    {
      path: '/app/article/chargespec',
      name: 'ChargeSpec',
      component: ChargeSpec
    },
    {
      path: '/form',
      name: 'RepairForm',
      component: RepairForm
    },
    {
      path: '/template',
      name: 'RepairTemplate',
      component: RepairTemplate
    },
    {
      path: '/form/create',
      name: 'CreateRepairForm',
      component: CreateRepairForm
    },
    {
      path: '/form/edit/:id',
      name: 'EditRepairForm',
      component: CreateRepairForm
    },
    {
      path: '/template/create',
      name: 'CreateRepairTemplate',
      component: CreateRepairTemplate
    },
    {
      path: '/template/edit/:id',
      name: 'EditRepairTemplate',
      component: CreateRepairTemplate
    },
    {
      path: '/tickets/:id',
      name: 'ViewRepairForm',
      component: ReportView
    },
    {
      path: '/tickets/:id/service',
      name: 'ViewServiceTicket',
      component: ReportServiceTicketView
    },
    {
      path: '/binding',
      name: 'Binding',
      component: Binding
    },
    {
      path: '/mgr/subdomain',
      name: 'SubDomainAudit',
      component: SubDomainAudit
    },
    {
      path: '/mgr/sp',
      name: 'ServiceProviderMgr',
      component: ServiceProviderMgr
    },
    {
      path: '/mgr/cusdomain',
      name: 'CustomerDomainAudit',
      component: CustomerDomainAudit
    },
    {
      path: '/mgr/rex',
      name: 'RevenueExpenditure',
      component: RevenueExpenditure
    },
    {
      path: '/mgr/miniapp',
      name: 'MiniAppView',
      component: MiniAppView
    },
    {
      path: '/mgr/compileapp',
      name: 'CompileAppView',
      component: CompileAppView
    },
    {
      path: '/mgr/feedback',
      name: 'FeedbackView',
      component: FeedbackView
    },
    {
      path: '/app/device-tmpl',
      name: 'DevicePresentView',
      component: DevicePresentView
    },
    {
      path: '/app/device-tmpl/:id',
      name: 'DevicePresentModify',
      component: DevicePresentModify
    },
  ]
});

router.afterEach((to, from) => {
  try {
    if (window.parent && window.parent.postMessage) {
      window.parent.postMessage(JSON.stringify({msg: 'EVENT_LBX_ROUTE_CHANGE', name: to.name, path: to.path}), '*');
    }
  } catch (e) {
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js